import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import s from './dre.scss';
// Just triggering a full build...
const DRE = ({ environment , dre  })=>{
    const [appInfo, updateAppInfo] = useState('n/a');
    useEffect(()=>{
        updateAppInfo(window['__APP_INFO__']);
    }, []);
    const url = Url.buildFromPath(`dre/share?dumpid=${dre === null || dre === void 0 ? void 0 : dre.dumpId}&token=${dre === null || dre === void 0 ? void 0 : dre.dumptoken}`, 'https://admin.deviantart.com/');
    const openWindow = ()=>{
        const win = window.open(url, 'DRE_Console', `left=100,top=225,width=${Math.round(document.body.offsetWidth * 0.8)},height=${Math.round(screen.height * 0.7)},toolbar = 0, scrollbars = 1, location = 0, status = 0, statusmenubar = 0, resizable = 1`);
        if (!win) {
            return alert('DRE window has been blocked as a popup');
        }
        win.focus();
    };
    const wrapEvent = (eventCount, label)=>{
        if (!eventCount) {
            return `0${label}`;
        }
        return /*#__PURE__*/ React.createElement("span", null, /*#__PURE__*/ React.createElement("strong", null, eventCount), label);
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], (dre === null || dre === void 0 ? void 0 : dre.alarmEvents) && (dre === null || dre === void 0 ? void 0 : dre.alarmEvents) > 0 && s['alert']),
        onClick: openWindow
    }, dre === null || dre === void 0 ? void 0 : dre.hostname, " ", dre === null || dre === void 0 ? void 0 : dre.totaltime, "ms ", /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("span", {
        className: s['alarms']
    }, wrapEvent(dre === null || dre === void 0 ? void 0 : dre.alarmEvents, 'A')), ' ', wrapEvent(dre === null || dre === void 0 ? void 0 : dre.warningEvents, 'W'), " ", wrapEvent(dre === null || dre === void 0 ? void 0 : dre.noticeEvents, 'N'), ' ', (dre === null || dre === void 0 ? void 0 : dre.myEvents) && wrapEvent(dre === null || dre === void 0 ? void 0 : dre.myEvents, 'M'), ' ', (dre === null || dre === void 0 ? void 0 : dre.quickEvents) && wrapEvent(dre === null || dre === void 0 ? void 0 : dre.quickEvents, 'Q'), ' ', wrapEvent(dre === null || dre === void 0 ? void 0 : dre.infoEvents, 'T'), /*#__PURE__*/ React.createElement("div", null, appInfo));
};
DRE.displayName = 'DRE';
export default DRE;
